exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".variations-toggle[data-v-60c97d02]{cursor:pointer}.variation-separator[data-v-60c97d02]{margin:0 4px;color:#c0c4cc}.variation-codes[data-v-60c97d02]{color:#909399}.variation-name .variation-codes[data-v-60c97d02]{display:block;padding-left:14px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-60c97d02","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/views/tenant/items/index.vue
// module id = pDF1
// module chunks = 0